import React, { useEffect, useMemo, useState } from 'react';
import {
  Box, Paper, Stack, Typography, Divider, Button, Chip, Tooltip,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useTheme } from '@emotion/react';
import { useSelector } from 'react-redux';
import { Loader, SelectDropdown, Wrapper } from '../../components';
import { Article, CarbonApi } from '../../assets';
import { Logs, apiCategortList } from '../../services';
import { keysPair } from '../../services/keysPairService';
import { DisplayScreen } from './displayScreen';
import { useLocation, useNavigate } from 'react-router-dom';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import WalletIcon from '@mui/icons-material/Wallet';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { notification } from 'antd';
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export function Playground() {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const [apiServiceAndList, setApiServiceAndList] = useState({});
  const [selectedService, setSelectedService] = useState("");
  const [selectedEndpoint, setSelectedEndpoint] = useState("");
  const [status, setStatus] = useState(null);
  const [queryParamsFlag, setQueryParamsFlag] = useState(false);
  const [endpointCredList, setEndpointCredList] = useState([]);
  const [selectedApiKey, setSelectedApiKey] = useState('');
  const [file, setFile] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const [jsonData, setJsonData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState({
    error: null,
    uploaded: null,
    masked: null,
    status: null,
  });

  const emailsToCheck = [
    "vinod.kumawat@habilelabs.io",
    "reena@habilelabs.io", 
    "babudevatwal1996@gmail.com",
  ];

  const isEmailMatch = useMemo(() => {
    return emailsToCheck?.includes(userDetails?.email);
  }, [userDetails?.email]);

  const [serviceChange, setServiceChange] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
  
      try {
        const res = await apiCategortList();
        if (res?.status === 200) {
          const services = res?.data?.data?.attributes?.apisByCategory || {};
  
          const filteredServices = Object.fromEntries(
            Object.entries(services).map(([category, data]) => [
              category,
              {
                ...data,
                apis: data.apis.filter(
                  (api) => api.name.toLowerCase() !== "auth url digilocker"
                ),
              },
            ])
          );
  
          setApiServiceAndList(filteredServices);
          const sortedServices = Object.keys(filteredServices).sort();
          setSelectedService(sortedServices[0] || "");
        }
      } catch (error) {
        Logs(error);
      }
  
      try {
        const response = await keysPair({ id: user?.company?.id });
  
        const data = response?.data?.data?.map((item) => ({
            id: item.id,
            apiKey: item.attributes.apiKey,
            apiSecret: item.attributes.apiSecret,
            apiAccessKeysName: item.attributes.apiAccessKeysName,
            apis: item.attributes?.apis?.data.map((api) => api.id),
          })) || [];
  
        setEndpointCredList(data);
        if (data.length > 0 && !selectedApiKey) {
          setSelectedApiKey(data[0].id.toString());
        }
      } catch (error) {
        console.error("Error fetching endpoint data:", error);
      } finally {
        setLoading(false);
      }
    };
    
      fetchData();
    
  }, [user?.company?.id]);

  useEffect(() => {
    if (
      !serviceChange &&
      selectedService &&
      apiServiceAndList[selectedService]?.apis
    ) {
      const sortedEndpoints = apiServiceAndList[selectedService]?.apis.sort(
        (a, b) => a.name.localeCompare(b.name)
      );
      const firstEndpoint = sortedEndpoints[0] || null;
      if (!Array.isArray(endpointCredList)) {
        console.error("endpointCredList is not an array:", endpointCredList);
        return;
      }
      if (firstEndpoint && firstEndpoint.id) {
        setSelectedEndpoint(firstEndpoint.id);
        let pickedSecret = selectedApiKey 
          ? endpointCredList?.find(cred => cred.id === parseInt(selectedApiKey))
          : endpointCredList?.find(
              (cred) =>
                Array.isArray(cred.apis) && cred?.apis?.includes(firstEndpoint.id)
            ) || null;
        if (pickedSecret) {
          sessionStorage.setItem("apiKey", pickedSecret.apiKey);
          sessionStorage.setItem("apiSecret", pickedSecret.apiSecret);
        } else {
          sessionStorage.setItem("apiKey", "");
          sessionStorage.setItem("apiSecret", "");
        }
      } else {
        setSelectedEndpoint("");
        sessionStorage.setItem("apiKey", "");
        sessionStorage.setItem("apiSecret", "");
      }
    }
  }, [selectedService, endpointCredList, serviceChange]);

  useEffect(() => {
    if (selectedEndpoint) {
      const pickedSecret = selectedApiKey 
        ? endpointCredList?.find(cred => cred.id === parseInt(selectedApiKey))
        : endpointCredList?.find(
            (cred) =>
              Array.isArray(cred.apis) && cred?.apis?.includes(selectedEndpoint)
          ) || null;
      if (pickedSecret) {
        sessionStorage.setItem("apiKey", pickedSecret.apiKey);
        sessionStorage.setItem("apiSecret", pickedSecret.apiSecret);
      } else {
        sessionStorage.setItem("apiKey", "");
        sessionStorage.setItem("apiSecret", "");
      }
    }
  }, [selectedEndpoint, endpointCredList, selectedApiKey]);

  const getSelectedEndpointInfo = (endpointId) => {
    const services = Object.values(apiServiceAndList);
    for (const service of services) {
      const foundEndpoint = service.apis.find((endpoint) => endpoint.id === endpointId);
      if (foundEndpoint) {
        return foundEndpoint;
      }
    }
    return null;
  };

  const handleServiceChange = (value) => {
    setStatus(null);
    setServiceChange(false);
    setSelectedService(value);
  };

  const { endpointOptions, endpoint } = useMemo(() => {
    const selected = apiServiceAndList[selectedService] || [];
    if (selected?.apis?.length > 0) {
      const sortedEndpointOptions = selected?.apis
        .map((item) => ({
          label: item.name,
          value: item.id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      const selectedEndpointObj = selected.apis.find((x) => x.id === selectedEndpoint);
      return { endpointOptions: sortedEndpointOptions, endpoint: selectedEndpointObj };
    }
    return { endpointOptions: [], endpoint: null };
  }, [selectedService, apiServiceAndList, selectedEndpoint]);

  useEffect(() => {
    if (endpoint?.apiInput?.[0]?.queryParam !== undefined) {
      setQueryParamsFlag(endpoint.apiInput[0].queryParam);
    }
  }, [endpoint]);

  const handleClick = () => {
    const selectedEndpointObj = getSelectedEndpointInfo(selectedEndpoint);
    if (selectedEndpointObj) {
      navigate("/endpoint-documentation", {
        state: {
          selectedSubService: selectedEndpointObj.name,
          selectedService: selectedService,
          showBackButton: true,
        },
      });
    } else {
      console.error("Selected endpoint not found.");
    }
  };

  const handleAddClick = () => {
    setOpenDialog(true);
  };

  const handleLibraryClick = () => {
    navigate("/library");
  };

  let creditText = "";
  if (endpoint?.creditConsumptionValue !== undefined) {
    const creditValue = endpoint?.creditConsumptionValue ?? 0;
    creditText =
      creditValue > 1
        ? `${creditValue} credits per request`
        : `${creditValue} credit per request`;
  } else {
    creditText = "credit per request";
  }

  let creditPerAadhaar = "";
  if (endpoint?.pricingPerPage !== undefined) {
    const aadhaarValue = endpoint?.pricingPerPage ?? 0;
    creditPerAadhaar =
      aadhaarValue > 1
        ? `${aadhaarValue} credits per page`
        : `${aadhaarValue} credits per page`;
  } else {
    creditPerAadhaar = "credits per page";
  }

  const isMobile = useMediaQuery("(max-width:899px)");

  const endpointStatus = getSelectedEndpointInfo(selectedEndpoint)?.apiStatus;
  const endpointInstruction = getSelectedEndpointInfo(selectedEndpoint)?.apiStatusInstruction;

  return (
    <Wrapper>
      {loading && <Loader />}
      <Paper sx={{mt:'3P0px'}}>
        <Stack
          direction="row"
          sx={{ pt: 2, px: 2, pb: "0.6rem", mt: { xs: 10, sm: 12, md: 12 }, mb: 2  }}
          spacing={2}
          justifyContent="space-between"
        >
          <Box sx={{ display: "flex", flexDirection: "row", gap: "10px" }}>
            <Box
              component="img"
              src={CarbonApi}
              sx={{ width: { xs: "auto" } }}
            />
            <Typography
              variant="h4"
              sx={{
                color: theme.palette.textColor.primary,
                fontSize: { xs: "1.5rem", md: "2rem" },
              }}
            >
              Select Service
            </Typography>
          </Box>
          {isEmailMatch && (
            <Box sx={{ display: "flex", flexDirection: "row", gap: "15px" }}>
              {file && (jsonData || image?.masked) && (
                <Tooltip title="Add to Library">
                  <AddBoxIcon
                    color="primary"
                    sx={{ fontSize: 24, cursor: "pointer" }}
                    onClick={handleAddClick}
                  />
                </Tooltip>
              )}

              <Tooltip title="Show Library">
                <WalletIcon
                  color="primary"
                  sx={{ fontSize: 24, cursor: "pointer" }}
                  onClick={handleLibraryClick}
                />
              </Tooltip>
            </Box>
          )}
        </Stack>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "column", md: "row" },
            p: 3,
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "column", md: "row" },
              gap: 2,
            }}
          >
            <Stack
              spacing={1}
              sx={{ width: { xs: "100%", sm: "auto", md: "auto" } }}
            >
              <Typography
                variant="body1"
                sx={{ color: theme.palette.grey.darken4 }}
              >
                Type of Service
              </Typography>
              <SelectDropdown
                menuOptions={Object.keys(apiServiceAndList)
                  .sort()
                  .map((service) => ({
                    label: service,
                    value: service,
                  }))}
                value={selectedService}
                onChange={(value) => {
                  handleServiceChange(value);
                  setFile(null);
                }}
                widthSize={isMobile ? "100%" : "22rem"}
              />
            </Stack>
            <Stack
              spacing={1}
              sx={{ width: { xs: "100%", sm: "auto", md: "auto" } }}
            >
              <Typography
                variant="body1"
                sx={{ color: theme.palette.grey.darken4 }}
              >
                Endpoints
              </Typography>
              <SelectDropdown
                menuOptions={endpointOptions}
                value={selectedEndpoint}
                onChange={(value) => {
                  setSelectedEndpoint(value);
                  setStatus(null);
                  setFile(null);
                }}
                widthSize={isMobile ? "100%" : "22rem"}
              />
            </Stack>
          </Box>
          
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              alignItems: "center",
            }}
          >
            <Stack
              spacing={1}
              sx={{ width: { xs: "100%", sm: "auto", md: "auto" } }}
            >
              <Typography
                variant="body1"
                sx={{ color: theme.palette.grey.darken4 }}
              >
                API Key
              </Typography>
              <SelectDropdown
                menuOptions={endpointCredList.map(cred => ({
                  label: cred.apiAccessKeysName || `API Key ${cred.id}`,
                  value: cred.id.toString()
                }))}
                value={selectedApiKey}
                onChange={(value) => {
                  setSelectedApiKey(value);
                  setStatus(null);
                  setFile(null);
                }}
                widthSize={isMobile ? "100%" : "22rem"}
                placeholder="Auto-select"
              />
            </Stack>

            {endpointInstruction && (
              <Chip
                icon={<WarningIcon color="error" />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography variant="body1">
                      {endpointInstruction}
                    </Typography>
                  </Box>
                }
                sx={{
                  backgroundColor: "#fdecea",
                  color: "black",
                  height: "30px",
                  width: "auto",
                  padding: "0 8px",
                  border: "none",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            )}
          </Box>
        </Box>
      </Paper>
      <Paper>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            pt: 2,
            px: 2,
            pb: "0.6rem",
          }}
        >
          <Box sx={{ display: "flex", gap: 2, mb: { xs: 2, md: 0 } }}>
            <Box component="img" src={Article} sx={{ width: "auto" }} />

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {endpointStatus === "Online" && (
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: "green",
                  }}
                />
              )}
              {endpointStatus === "Offline" && (
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: "red",
                  }}
                />
              )}

              <Typography
                variant="h4"
                sx={{
                  color: theme.palette.textColor.primary,
                  fontSize: { xs: "1.5rem", md: "2rem" },
                }}
              >
                {endpoint?.name}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "end",
              gap: "15px",
              alignItems: "center",
            }}
          >
            {
              endpoint?.pricingPerPage !== null && (
                <Typography
                  variant="h5"
                  sx={{
                    color: theme.palette.textColor.blue,
                    background: theme.palette.background.light,
                    borderRadius: 2,
                    px: "12px",
                    py: "2px",
                  }}
                >
                  {creditPerAadhaar}
                </Typography>
              )}

            <Box>
              <Typography
                variant="h5"
                sx={{
                  color: theme.palette.textColor.blue,
                  background: theme.palette.background.light,
                  borderRadius: 2,
                  px: "12px",
                  py: "2px",
                }}
              >
                {creditText}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Divider />
        <DisplayScreen
          queryParamsFlag={queryParamsFlag}
          apiInput={endpoint?.apiInput}
          jsonData={jsonData}
          setJsonData={setJsonData}
          apiResponse={endpoint?.apiResponse}
          apiUrl={endpoint?.apiUrl}
          file={file}
          status={status}
          setStatus={setStatus}
          setFile={setFile}
          image={image}
          setImage={setImage}
          linkedApis={endpoint?.linkedApis}
          selectedAPI={selectedEndpoint}
          selectedCategory={selectedService}
          apiCategoryAndList={apiServiceAndList}
          api={endpoint}
        />
      </Paper>
    </Wrapper>
  );
}